const rooms = [
    {
        id : 1,
        title : {
            fr : 'Chambre Standard',
            en : 'Standard room'
        },
        description : {
            fr : 'Les chambres standard sont équipé de lit, tv, climatisation, sale de bain, table de lecture et chaise.',
            en : 'The standard rooms are equipped with bed, tv, air conditioning, bathroom, reading table and chair.'
        },
        guest : 2,
        size: 22,
        price: 12000,
        badge: '',
        image: 'assets/img/rooms/standard/1.jpg',
        images: ['assets/img/rooms/standard/1.jpg','assets/img/rooms/standard/2.jpg','assets/img/rooms/standard/3.jpg','assets/img/rooms/standard/4.webp','assets/img/rooms/standard/5.jpg','assets/img/rooms/standard/6.jpg'],
        desc : {
            title : {
                fr : "La Chambre Standard de L'Hôtel West Heaven vous attend!",
                en : 'The West Heaven Hotel Standard room is waiting for you!'
            },
            content:  {
                fr : "A l'Hôtel West Heaven, toutes nos chambres sont entièrement insonorisées et climatisées pour vous offrir calme et confort, la chambre standard ne fait pas exception. Avec une belle vue sur le jolie jardin, vous n'hésiterez pas à prendre un peu l'air quand l'envie vous prendra. A l'intérieur de la chambre, une smart TV pour vos moments de détente ainsi qu'un joli bureau en bois fin pour vos moments de lecture, de concentration ou de travail. Enfin, une douche lumineuse toujours équipée et un service de toilettes pour que vous ne manquiez de rien.<br/>Bienvenue à l'Hôtel West Heaven.",
                en : "At The West Heaven Hotel, all our rooms are fully soundproofed and air-conditioned to offer you peace and comfort, the standard room is no exception. With a beautiful view of the pretty garden, you will not hesitate to take a breath of fresh air when you feel like it. Inside the room, a smart TV for your moments of relaxation as well as a nice desk in fine wood for your moments of reading, concentration or work. Finally, a bright shower always equipped and a toilet service so that you do not miss anything.<br/>Welcome to the West Heaven Hotel.",
            },
        },
        features : [
            {
                title: 'shower',
                image: 'assets/img/features/shower.svg',
            },
            {
                title: 'toiletService',
                image: 'assets/img/features/restservice.svg',
            },
            {
                title: 'bidet',
                image: 'assets/img/features/bidet.svg',
            },
            {
                title: 'smartTV',
                image: 'assets/img/features/7.svg',
            },
            {
                title: 'airConditioned',
                image: 'assets/img/features/3.svg',
            },
            {
                title: 'soundproofing',
                image: 'assets/img/features/sonno.svg',
            },
            {
                title: 'gardenView',
                image: 'assets/img/features/garden.svg',
            },
            {
                title: 'desk',
                image: 'assets/img/features/desk.svg',
            },
            {
                title: 'wardrobe',
                image: 'assets/img/features/dressing.svg',
            },
            {
                title: 'breakfast',
                image: 'assets/img/features/2.svg',
            },
        ],
        category : 'standard'
    },
    {
        id : 2,
        title : {
            fr : 'Chambre Confort',
            en : 'Comfort room'
        },
        description : {
            fr : "Les chambres confort sont climatisées et bien équipées en plus d'un modeste balcon avec vue sur le fleuve.",
            en : 'The comfort rooms are air-conditioned and well-equipped, with a modest balcony overlooking the river.'
        },
        guest : 2,
        size: 30,
        price: 18000,
        badge: 'Popular',
        image: 'assets/img/rooms/confort/1.jpg',
        images: ['assets/img/rooms/confort/1.jpg','assets/img/rooms/confort/2.jpg','assets/img/rooms/confort/3.jpg','assets/img/rooms/confort/4.jpg','assets/img/rooms/standard/4.webp','assets/img/rooms/standard/5.jpg'],
        desc : {
            title : {
                fr : "La Chambre Confort de L'Hôtel West Heaven vous attend!",
                en : 'The West Heaven Hotel Comfort room is waiting for you!'
            },
            content:  {
                fr : "A l'Hôtel West Heaven, toutes nos chambres sont entièrement insonorisées et climatisées pour vous offrir calme et confort, la chambre confort ne fait pas exception. Avec un modeste balcon offrant une belle vue sur le fleuve wouri, vous n'hésiterez pas à prendre un peu l'air quand l'envie vous prendra. A l'intérieur de la chambre, une smart TV pour vos moments de détente, un téléphone et un access wifi pour rester connecter, Un joli bureau en bois fin pour vos moments de lecture, de concentration ou de travail. Aussi éqipé d'un Frigo, d'un Sofa et Guéridon. Enfin, une douche lumineuse toujours équipée et un service de toilettes pour que vous ne manquiez de rien. Votre valise est grande et pleine d'habits? Vous disposé d'une grande penderie pour se faire.<br/>Bienvenue à l'Hôtel West Heaven.",
                en : "At West Heaven Hotel, all our rooms are fully soundproofed and air-conditioned to offer you calm and comfort, the comfort room is no exception. With a modest balcony offering a beautiful view of the river wouri, you will not hesitate to take a little air when the desire will take you. Inside the room, a smart TV for your moments of relaxation, a telephone and a wifi access to stay connected, a nice desk in fine wood for your moments of reading, concentration or work. Also equipped with a fridge, a sofa and a table. Finally, a luminous shower always equipped and a toilet service so that you do not miss anything. Your suitcase is big and full of clothes? You will have a large wardrobe to do so.<br/>Welcome to the West Heaven Hotel.",
            },
        },
        features : [
            {
                title: 'shower',
                image: 'assets/img/features/shower.svg',
            },
            {
                title: 'toiletService',
                image: 'assets/img/features/restservice.svg',
            },
            {
                title: 'bidet',
                image: 'assets/img/features/bidet.svg',
            },
            {
                title: 'smartTV',
                image: 'assets/img/features/7.svg',
            },
            {
                title: 'freeTelephone',
                image: 'assets/img/features/10.svg',
            },
            {
                title: 'freeWifi',
                image: 'assets/img/features/6.svg',
            },
            {
                title: 'airConditioned',
                image: 'assets/img/features/3.svg',
            },
            {
                title: 'soundproofing',
                image: 'assets/img/features/sonno.svg',
            },
            {
                title: 'balcony',
                image: 'assets/img/features/balcony.svg',
            },
            {
                title: 'gardenView',
                image: 'assets/img/features/garden.svg',
            },
            {
                title: 'desk',
                image: 'assets/img/features/desk.svg',
            },
            {
                title: 'wardrobe',
                image: 'assets/img/features/dressing.svg',
            },
            {
                title: 'breakfast',
                image: 'assets/img/features/2.svg',
            },
        ],
        category : 'comfort'
    },
    {
        id : 3,
        title : {
            fr : 'Chambre Standard +',
            en : 'Standard+ room'
        },
        description : {
            fr : 'Les chambres standard sont équipé de lit, tv, climatisation, sale de bain, table de lecture + chaise et placard.',
            en : 'Les chambres standard sont équipé de lit, tv, climatisation, sale de bain, table de lecture + chaise et placard.'
        },
        guest : 4,
        size: 25,
        price: 12000,
        badge: '',
        image: 'assets/img/rooms/standardplus/1.jpg',
        images: ['assets/img/rooms/standardplus/1.jpg','assets/img/rooms/standardplus/2.jpg','assets/img/rooms/standardplus/3.jpg','assets/img/rooms/standardplus/4.jpg','assets/img/rooms/standard/4.webp','assets/img/rooms/standard/5.jpg'],
        desc : {
            title : {
                fr : "La Chambre Standard+ de L'Hôtel West Heaven vous attend!",
                en : 'The West Heaven Hotel Standard+ room is waiting for you!'
            },
            content:  {
                fr : "A l'Hôtel West Heaven, toutes nos chambres sont entièrement insonorisées et climatisées pour vous offrir calme et confort, la chambre standard ne fait pas exception. Avec une belle vue sur le jolie jardin, vous n'hésiterez pas à prendre un peu l'air quand l'envie vous prendra. A l'intérieur de la chambre, une smart TV pour vos moments de détente ainsi qu'un joli bureau en bois fin pour vos moments de lecture, de concentration ou de travail. Enfin, une douche lumineuse toujours équipée et un service de toilettes pour que vous ne manquiez de rien. Votre valise est grande et pleine d'habits? Vous disposé d'une grande penderie pour se faire.  <br/> Bienvenue à l'Hôtel West Heaven!",
                en : "At The West Heaven Hotel, all our rooms are fully soundproofed and air-conditioned to offer you peace and comfort, the standard room is no exception. With a beautiful view of the pretty garden, you will not hesitate to take a breath of fresh air when you feel like it. Inside the room, a smart TV for your moments of relaxation as well as a nice desk in fine wood for your moments of reading, concentration or work. Finally, a bright shower always equipped and a toilet service so that you do not miss anything. Your suitcase is large and full of clothes? you have a large wardrobe to make yourself at home. <br/> Welcome to the West Heaven Hotel!",
            },
        },
        features : [
            {
                title: 'shower',
                image: 'assets/img/features/shower.svg',
            },
            {
                title: 'toiletService',
                image: 'assets/img/features/restservice.svg',
            },
            {
                title: 'bidet',
                image: 'assets/img/features/bidet.svg',
            },
            {
                title: 'smartTV',
                image: 'assets/img/features/7.svg',
            },
            {
                title: 'airConditioned',
                image: 'assets/img/features/3.svg',
            },
            {
                title: 'soundproofing',
                image: 'assets/img/features/sonno.svg',
            },
            {
                title: 'gardenView',
                image: 'assets/img/features/garden.svg',
            },
            {
                title: 'desk',
                image: 'assets/img/features/desk.svg',
            },
            {
                title: 'wardrobe',
                image: 'assets/img/features/dressing.svg',
            },
            {
                title: 'breakfast',
                image: 'assets/img/features/2.svg',
            },
        ],
        category : 'standard'
    },
    {
        id : 4,
        title : {
            fr : 'Chambre Senior',
            en : 'Senior room'
        },
        description : {
            fr : "Les chambres senior sont climatisées et super équipées en plus d'un grand balcon avec vue sur le fleuve et le jardin.",
            en : 'The senior rooms are air-conditioned and super-equipped, with a large balcony overlooking the river and the garden.'
        },
        guest : 2,
        size: 35,
        price: 25000,
        badge: '',
        image: 'assets/img/rooms/senior/1.jpg',
        images: ['assets/img/rooms/senior/1.jpg','assets/img/rooms/senior/2.jpg','assets/img/rooms/senior/3.jpg','assets/img/rooms/senior/4.jpg','assets/img/rooms/senior/5.jpg','assets/img/rooms/standard/4.webp','assets/img/rooms/standard/5.jpg'],
        desc : {
            title : {
                fr : "La Chambre Senior+ de L'Hôtel West Heaven vous attend!",
                en : 'The West Heaven Hotel Senior+ room is waiting for you!'
            },
            content:  {
                fr : "A l'Hôtel West Heaven, toutes nos chambres sont entièrement insonorisées et climatisées pour vous offrir calme et confort, la chambre senior ne fait pas exception. Avec un grand balcon offrant une belle vue sur le fleuve wouri et le jardin, vous n'hésiterez pas à prendre un peu l'air quand l'envie vous prendra. A l'intérieur de la chambre, une smart TV pour vos moments de détente, un téléphone et un access wifi pour rester connecter, Un joli bureau en bois fin pour vos moments de lecture, de concentration ou de travail. Aussi éqipé d'un Frigo, d'un Sofa et Guéridon. Enfin, une douche lumineuse toujours équipée et un service de toilettes pour que vous ne manquiez de rien. Votre valise est grande et pleine d'habits? Vous disposé d'une grande penderie pour se faire.<br/>Bienvenue à l'Hôtel West Heaven.",
                en : "At West Heaven Hotel, all our rooms are fully soundproofed and air-conditioned to offer you calm and comfort, the senior room is no exception. With a large balcony offering a beautiful view of the river wouri and the garden, you will not hesitate to take a little air when the desire will take you. Inside the room, a smart TV for your moments of relaxation, a telephone and a wifi access to stay connected, a nice desk in fine wood for your moments of reading, concentration or work. Also equipped with a fridge, a sofa and a table. Finally, a luminous shower always equipped and a toilet service so that you do not miss anything. Your suitcase is big and full of clothes? You will have a large wardrobe to do so.<br/>Welcome to the West Heaven Hotel.",
            },
        },
        features : [
            {
                title: 'shower',
                image: 'assets/img/features/shower.svg',
            },
            {
                title: 'toiletService',
                image: 'assets/img/features/restservice.svg',
            },
            {
                title: 'bidet',
                image: 'assets/img/features/bidet.svg',
            },
            {
                title: 'smartTV',
                image: 'assets/img/features/7.svg',
            },
            {
                title: 'freeTelephone',
                image: 'assets/img/features/10.svg',
            },
            {
                title: 'freeWifi',
                image: 'assets/img/features/6.svg',
            },
            {
                title: 'airConditioned',
                image: 'assets/img/features/3.svg',
            },
            {
                title: 'soundproofing',
                image: 'assets/img/features/4.svg',
            },
            {
                title: 'balcony',
                image: 'assets/img/features/balcony.svg',
            },
            {
                title: 'riverView',
                image: 'assets/img/features/sea.svg',
            },
            {
                title: 'gardenView',
                image: 'assets/img/features/garden.svg',
            },
            {
                title: 'desk',
                image: 'assets/img/features/desk.svg',
            },
            {
                title: 'wardrobe',
                image: 'assets/img/features/dressing.svg',
            },
            {
                title: 'breakfast',
                image: 'assets/img/features/2.svg',
            },
        ],
        category : 'senior'
    },
    {
        id : 5,
        title : {
            fr : 'Chambre Senior+',
            en : 'Senior+ room'
        },
        description : {
            fr : "Les chambres senior+ sont climatisées et super équipées en plus d'un grand balcon avec vue sur le fleuve et le jardin.",
            en : 'The senior+ rooms are air-conditioned and super-equipped, with a large balcony overlooking the river and the garden.'
        },
        guest : 2,
        size: 35,
        price: 25000,
        badge: '',
        image: 'assets/img/rooms/senior/1.jpg',
        images: ['assets/img/rooms/senior/1.jpg','assets/img/rooms/senior/2.jpg','assets/img/rooms/senior/3.jpg','assets/img/rooms/senior/4.jpg','assets/img/rooms/senior/5.jpg','assets/img/rooms/standard/4.webp','assets/img/rooms/standard/5.jpg'],
        desc : {
            title : {
                fr : "La Chambre Senior+ de L'Hôtel West Heaven vous attend!",
                en : 'The West Heaven Hotel Senior+ room is waiting for you!'
            },
            content:  {
                fr : "A l'Hôtel West Heaven, toutes nos chambres sont entièrement insonorisées et climatisées pour vous offrir calme et confort, la chambre senior ne fait pas exception. Avec un grand balcon offrant une belle vue sur le fleuve wouri et le jardin, vous n'hésiterez pas à prendre un peu l'air quand l'envie vous prendra. A l'intérieur de la chambre, une smart TV pour vos moments de détente, un téléphone et un access wifi pour rester connecter, Un joli bureau en bois fin pour vos moments de lecture, de concentration ou de travail. Aussi éqipé d'un Frigo, d'un Sofa et Guéridon. Enfin, une douche lumineuse toujours équipée et un service de toilettes pour que vous ne manquiez de rien. Votre valise est grande et pleine d'habits? Vous disposé d'une grande penderie pour se faire.<br/>Bienvenue à l'Hôtel West Heaven.",
                en : "At West Heaven Hotel, all our rooms are fully soundproofed and air-conditioned to offer you calm and comfort, the senior room is no exception. With a large balcony offering a beautiful view of the river wouri and the garden, you will not hesitate to take a little air when the desire will take you. Inside the room, a smart TV for your moments of relaxation, a telephone and a wifi access to stay connected, a nice desk in fine wood for your moments of reading, concentration or work. Also equipped with a fridge, a sofa and a table. Finally, a luminous shower always equipped and a toilet service so that you do not miss anything. Your suitcase is big and full of clothes? You will have a large wardrobe to do so.<br/>Welcome to the West Heaven Hotel.",
            },
        },
        features : [
            {
                title: 'shower',
                image: 'assets/img/features/shower.svg',
            },
            {
                title: 'toiletService',
                image: 'assets/img/features/restservice.svg',
            },
            {
                title: 'bidet',
                image: 'assets/img/features/bidet.svg',
            },
            {
                title: 'smartTV',
                image: 'assets/img/features/7.svg',
            },
            {
                title: 'freeTelephone',
                image: 'assets/img/features/10.svg',
            },
            {
                title: 'freeWifi',
                image: 'assets/img/features/6.svg',
            },
            {
                title: 'airConditioned',
                image: 'assets/img/features/3.svg',
            },
            {
                title: 'soundproofing',
                image: 'assets/img/features/4.svg',
            },
            {
                title: 'balcony',
                image: 'assets/img/features/balcony.svg',
            },
            {
                title: 'riverView',
                image: 'assets/img/features/sea.svg',
            },
            {
                title: 'gardenView',
                image: 'assets/img/features/garden.svg',
            },
            {
                title: 'desk',
                image: 'assets/img/features/desk.svg',
            },
            {
                title: 'wardrobe',
                image: 'assets/img/features/dressing.svg',
            },
            {
                title: 'breakfast',
                image: 'assets/img/features/2.svg',
            },
        ],
        category : 'senior'
    },
    {
        id : 6,
        title : {
            fr : 'Chambre Confort+',
            en : 'Comfort+ room'
        },
        description : {
            fr : "Les chambres confort+ sont climatisées et bien équipées en plus d'un modeste balcon avec vue sur le fleuve.",
            en : 'The comfort+ rooms are air-conditioned and well-equipped, with a modest balcony overlooking the river.'
        },
        guest : 2,
        size: 30,
        price: 18000,
        badge: '',
        image: 'assets/img/rooms/confort/1.jpg',
        images: ['assets/img/rooms/confort/1.jpg','assets/img/rooms/confort/2.jpg','assets/img/rooms/confort/3.jpg','assets/img/rooms/confort/4.jpg','assets/img/rooms/standard/4.webp','assets/img/rooms/standard/5.jpg'],
        desc : {
            title : {
                fr : "La Chambre Confort+ de L'Hôtel West Heaven vous attend!",
                en : 'The West Heaven Hotel Comfort+ room is waiting for you!'
            },
            content:  {
                fr : "A l'Hôtel West Heaven, toutes nos chambres sont entièrement insonorisées et climatisées pour vous offrir calme et confort, la chambre confort+ ne fait pas exception. Avec un modeste balcon offrant une belle vue sur le fleuve wouri, vous n'hésiterez pas à prendre un peu l'air quand l'envie vous prendra. A l'intérieur de la chambre, une smart TV pour vos moments de détente, un téléphone et un access wifi pour rester connecter, Un joli bureau en bois fin pour vos moments de lecture, de concentration ou de travail. Aussi éqipé d'un Frigo, d'un Sofa et Guéridon. Enfin, une douche lumineuse toujours équipée et un service de toilettes pour que vous ne manquiez de rien. Votre valise est grande et pleine d'habits? Vous disposé d'une grande penderie pour se faire.<br/>Bienvenue à l'Hôtel West Heaven.",
                en : "At West Heaven Hotel, all our rooms are fully soundproofed and air-conditioned to offer you calm and comfort, the comfort+ room is no exception. With a modest balcony offering a beautiful view of the river wouri, you will not hesitate to take a little air when the desire will take you. Inside the room, a smart TV for your moments of relaxation, a telephone and a wifi access to stay connected, a nice desk in fine wood for your moments of reading, concentration or work. Also equipped with a fridge, a sofa and a table. Finally, a luminous shower always equipped and a toilet service so that you do not miss anything. Your suitcase is big and full of clothes? You will have a large wardrobe to do so.<br/>Welcome to the West Heaven Hotel.",
            },
        },
        features : [
            {
                title: 'shower',
                image: 'assets/img/features/1.svg',
            },
            {
                title: 'toiletService',
                image: 'assets/img/features/2.svg',
            },
            {
                title: 'bidet',
                image: 'assets/img/features/3.svg',
            },
            {
                title: 'smartTV',
                image: 'assets/img/features/7.svg',
            },
            {
                title: 'freeTelephone',
                image: 'assets/img/features/10.svg',
            },
            {
                title: 'freeWifi',
                image: 'assets/img/features/6.svg',
            },
            {
                title: 'airConditioned',
                image: 'assets/img/features/3.svg',
            },
            {
                title: 'soundproofing',
                image: 'assets/img/features/4.svg',
            },
            {
                title: 'balcony',
                image: 'assets/img/features/10.svg',
            },
            {
                title: 'gardenView',
                image: 'assets/img/features/10.svg',
            },
            {
                title: 'desk',
                image: 'assets/img/features/6.svg',
            },
            {
                title: 'wardrobe',
                image: 'assets/img/features/8.svg',
            },
            {
                title: 'breakfast',
                image: 'assets/img/features/2.svg',
            },
        ],
        category : 'comfort'
    }
]

export default rooms